































































import { computed, defineComponent, ref } from "@vue/composition-api";
import { UploadVaultFile } from "@/types";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import BaseIcon from "@/components/BaseIcon";
import InfiniteScroll from "@/components/InfiniteScroll";
import VaultFilesList from "../VaultFilesList";

export default defineComponent({
  name: "VaultManageView",
  components: {
    VaultFilesList,
    InfiniteScroll,
    BaseButton,
    BaseIcon,
    BaseConfirm,
  },
  props: {
    vaultFiles: { type: Array as () => UploadVaultFile[], required: true },
    scroll: { type: Boolean },
    loading: { type: Boolean, default: false },
  },
  setup(_, { emit }) {
    const checkedFiles = ref<UploadVaultFile[]>([]);
    const noCheckedFiles = computed(() => checkedFiles.value.length === 0);
    const showDeletedConfirm = ref<boolean>(false);

    const resetState = () => {
      checkedFiles.value = [];
      showDeletedConfirm.value = false;
    };

    const onMoveClick = (): void => {
      emit("move:files", checkedFiles.value, resetState);
    };
    const onDeleteFiles = async () => {
      emit("deleteFilesFromCategory", checkedFiles.value, resetState);
    };

    return {
      checkedFiles,
      noCheckedFiles,
      showDeletedConfirm,
      onMoveClick,
      onDeleteFiles,
    };
  },
});
